import Macy from 'macy'
import BigPicture from 'bigpicture'
import dlv from 'dlv'
import { getDataAttributes } from '../util/util'

const { body } = document

export default {
	// init() {
	// },
	finalize() {
		mediaGrid()

		// outline only if using keyboard
		body.addEventListener('mousedown', () => body.classList.add('using-mouse'))
		body.addEventListener('keydown', () => body.classList.remove('using-mouse'))
	},
}

function mediaGrid() {
	let mediaGridEl = document.getElementById('media_grid')
	if (!mediaGridEl) {
		return
	}
	let mediaLinks = Array.from(document.querySelectorAll('.mp-item a'))

	if (mediaLinks.length) {
		mediaLinks.forEach((link) => {
			let data = getDataAttributes(link)
			if (data.embed || data.audio) {
				link.addEventListener('click', (e) => {
					e.preventDefault()
					let img = link.parentNode.querySelector('img')
					let opts = {
						el: img ? img : link,
					}
					if (data.audio) {
						opts.audio = data.audio
					} else {
						let width = dlv(data, 'dimensions.width')
						let height = dlv(data, 'dimensions.height')
						opts.iframeSrc = data.embed
						if (width && height) {
							opts.dimensions = [width, height]
						}
					}
					BigPicture(opts)
				})
			}
		})
	}

	if (mediaLinks.length < 3) {
		mediaGridEl.classList.add('flex-media')
		return
	}
	Macy({
		container: mediaGridEl,
		columns: 3,
		margin: 25,
		breakAt: {
			1000: {
				columns: 2,
			},
			700: {
				columns: 1,
			},
		},
	})
}
